[
  {
    "name": "Savings Account",
    "experienceKey": "AssetsBank",
    "rate": 0.03,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsSavingsRegular",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": "catTechnicalVirtualBalance",
    "a_recurrentInflowCategoryKey": "catIncomeYieldsTaxable",
    "a_drawDownOrder": 3,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxExempt"
  },
  {
    "name": "Cash",
    "experienceKey": "AssetsBank",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsCash",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": "catTechnicalVirtualBalance",
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": 1,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxExempt"
  },
  {
    "name": "Deposit",
    "experienceKey": "AssetsBank",
    "rate": 0.03,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsDeposit",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": "catTechnicalVirtualBalance",
    "a_recurrentInflowCategoryKey": "catIncomeYieldsTaxable",
    "a_drawDownOrder": 5,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxExempt"
  },
  {
    "name": "Checking Account",
    "experienceKey": "AssetsBank",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsChecking",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": "catTechnicalVirtualBalance",
    "a_recurrentInflowCategoryKey": "catIncomeYieldsTaxable",
    "a_drawDownOrder": 2,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxExempt"
  },
  {
    "name": "Money Market Account",
    "experienceKey": "AssetsBank",
    "rate": 0.05,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsMoneyMarket",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": "catTechnicalVirtualBalance",
    "a_recurrentInflowCategoryKey": "catIncomeYieldsTaxable",
    "a_drawDownOrder": 4,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxExempt"
  },
  {
    "name": "Group Life (GL)",
    "experienceKey": "AssetsInsurance",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsGroupLife",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": "catTechnicalVirtualBalance",
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Term Life (TL)",
    "experienceKey": "AssetsInsurance",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsTermLife",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": "catTechnicalVirtualBalance",
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Whole Life (WL)",
    "experienceKey": "AssetsInsurance",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsWholeLife",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsEmployer",
    "a_closeCategoryKey": "catTechnicalVirtualBalance",
    "a_recurrentInflowCategoryKey": "catIncomeYieldsTaxExempt",
    "a_drawDownOrder": 21,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxExempt"
  },
  {
    "name": "Death Benefit",
    "experienceKey": "AssetsInsurance",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsDeathBenefit",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Universal Life (IUL)",
    "experienceKey": "AssetsInsurance",
    "rate": 0.02,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsIndexedUniversalLife",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsEmployer",
    "a_closeCategoryKey": "catTechnicalVirtualBalance",
    "a_recurrentInflowCategoryKey": "catIncomeYieldsTaxExempt",
    "a_drawDownOrder": 22,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxExempt"
  },
  {
    "name": "529 Plan",
    "experienceKey": "AssetsInvestment",
    "rate": 0.0615,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsSavings529",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": "catTechnicalVirtualBalance",
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": "catIncomeTaxExempt"
  },
  {
    "name": "Health Savings Account",
    "experienceKey": "AssetsInvestment",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsSavingsHealth",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": "catTechnicalVirtualBalance",
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": "catIncomeTaxExempt"
  },
  {
    "name": "Brokerage",
    "experienceKey": "AssetsInvestment",
    "rate": 0.0615,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsBrokerage",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": "catIncomeCapitalGains",
    "a_recurrentInflowCategoryKey": "catIncomeYieldsTaxable",
    "a_drawDownOrder": 6,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxExempt"
  },
  {
    "name": "Crypto",
    "experienceKey": "AssetsMiscellaneous",
    "rate": 0.2,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsCrypto",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": "catIncomeCapitalGains",
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": 10,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Collectables",
    "experienceKey": "AssetsMiscellaneous",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsCollectables",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catExpensesOther",
    "a_closeCategoryKey": "catIncomeCapitalGains",
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": 11,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Other",
    "experienceKey": "AssetsMiscellaneous",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsOther",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Primary Residence",
    "experienceKey": "RealEstate",
    "rate": 0.02,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsPrimaryResidence",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": "catExpensesPurchase",
    "a_closeCategoryKey": "catIncomeCapitalGains",
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Secondary Residence",
    "experienceKey": "RealEstate",
    "rate": 0.02,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsSecondaryResidence",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": "catExpensesPurchase",
    "a_closeCategoryKey": "catIncomeCapitalGains",
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Rental (Investment) Real Estate",
    "experienceKey": "RealEstate",
    "rate": 0.02,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsRentalRealEstate",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": "catExpensesPurchase",
    "a_closeCategoryKey": "catIncomeCapitalGains",
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Commercial Building",
    "experienceKey": "RealEstate",
    "rate": 0.02,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsCommercialBuilding",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": "catExpensesPurchase",
    "a_closeCategoryKey": "catIncomeCapitalGains",
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Land",
    "experienceKey": "RealEstate",
    "rate": 0.02,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsLand",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": "catExpensesPurchase",
    "a_closeCategoryKey": "catIncomeCapitalGains",
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "401(k), 403(b) Plan",
    "experienceKey": "AssetsRetirement",
    "rate": 0.0615,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsIra401k403b",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": true,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": "catTechnicalVirtualBalance",
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": 15,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxable"
  },
  {
    "name": "Roth 401(k), 403(b) Plan",
    "experienceKey": "AssetsRetirement",
    "rate": 0.0615,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsIra401k403bRoth",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": "catIncomeYieldsTaxExempt",
    "a_drawDownOrder": 24,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxExempt"
  },
  {
    "name": "457(b) Plan",
    "experienceKey": "AssetsRetirement",
    "rate": 0.0615,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsIra457b",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": true,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": "catTechnicalVirtualBalance",
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": 17,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxable"
  },
  {
    "name": "Roth 457(b) Plan",
    "experienceKey": "AssetsRetirement",
    "rate": 0.0615,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsIra457bRoth",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": "catIncomeYieldsTaxExempt",
    "a_drawDownOrder": 26,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxExempt"
  },
  {
    "name": "Solo 401(k) Plan (Self-Employed)",
    "experienceKey": "AssetsRetirement",
    "rate": 0.0615,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsIra401kSolo",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": true,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": 18,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxable"
  },
  {
    "name": "Roth Solo 401(k) Plan (Self-Employed)",
    "experienceKey": "AssetsRetirement",
    "rate": 0.0615,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsIra401kSoloRoth",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": "catIncomeYieldsTaxExempt",
    "a_drawDownOrder": 23,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxExempt"
  },
  {
    "name": "Roth IRA",
    "experienceKey": "AssetsRetirement",
    "rate": 0.0615,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsIraRoth",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": "catTechnicalVirtualBalance",
    "a_recurrentInflowCategoryKey": "catIncomeYieldsTaxExempt",
    "a_drawDownOrder": 27,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxExempt"
  },
  {
    "name": "Rollover IRA",
    "experienceKey": "AssetsRetirement",
    "rate": 0.0615,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsIraRollover",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": true,
    "a_isLiquid": true,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": "catTechnicalVirtualBalance",
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": 13,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxable"
  },
  {
    "name": "SIMPLE IRA",
    "experienceKey": "AssetsRetirement",
    "rate": 0.0615,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsIraSimple",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": true,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": "catTechnicalVirtualBalance",
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": 20,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxable"
  },
  {
    "name": "SEP IRA",
    "experienceKey": "AssetsRetirement",
    "rate": 0.0615,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsIraSep",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": true,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsEmployer",
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": 19,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxable"
  },
  {
    "name": "Traditional IRA",
    "experienceKey": "AssetsRetirement",
    "rate": 0.0615,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsIraTraditional",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": true,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": 14,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxable"
  },
  {
    "name": "Inherited IRA (Beneficiary)",
    "experienceKey": "AssetsRetirement",
    "rate": 0.0615,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsIraInherited",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": true,
    "a_isLiquid": true,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": 12,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxable"
  },
  {
    "name": "Stocks",
    "experienceKey": "AssetsEquity",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsStocks",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": "catIncomeCapitalGains",
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": 8,
    "a_withdrawalCategoryKey": "catIncomeCapitalGains"
  },
  {
    "name": "Bonds",
    "experienceKey": "AssetsEquity",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsBonds",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": "catIncomeCapitalGains",
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": 7,
    "a_withdrawalCategoryKey": "catIncomeCapitalGains"
  },
  {
    "name": "Stock-Based Compensation (RSUs, Stock Options)",
    "experienceKey": "AssetsEquity",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsRSU",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Credit Card Debt",
    "experienceKey": "LiabilitiesCredit",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catLiabilitiesCard",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Other Personal Loan",
    "experienceKey": "LiabilitiesCredit",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catLiabilitiesOther",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Student Loan",
    "experienceKey": "LiabilitiesCredit",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catLiabilitiesStudent",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Auto Loan",
    "experienceKey": "LiabilitiesCredit",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catLiabilitiesCar",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Mortgage",
    "experienceKey": "LiabilitiesCredit",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catLiabilitiesMortgage",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Lease",
    "experienceKey": "LiabilitiesCredit",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catLiabilitiesLease",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "HELOC",
    "experienceKey": "LiabilitiesLoc",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catLiabilitiesHeloc",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "LoC Personal",
    "experienceKey": "LiabilitiesLoc",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catLiabilitiesLocPersonal",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "LoC Business",
    "experienceKey": "LiabilitiesLoc",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catLiabilitiesLocBusiness",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Pledged Asset Line",
    "experienceKey": "LiabilitiesLoc",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catLiabilitiesPledgedAssetLine",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Salary",
    "experienceKey": "IncomeEmployment",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_retirement",
    "isTechnical": false,
    "isActiveIncome": true,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeSalary",
    "i_taxationType": "w2Wages",
    "adjustmentWeight": 1,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Bonus",
    "experienceKey": "IncomeEmployment",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_retirement",
    "isTechnical": false,
    "isActiveIncome": true,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeBonus",
    "i_taxationType": "w2Wages",
    "adjustmentWeight": 1,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Tips",
    "experienceKey": "IncomeEmployment",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_retirement",
    "isTechnical": false,
    "isActiveIncome": true,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeTips",
    "i_taxationType": "w2Wages",
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Capital Gains",
    "experienceKey": "IncomeInvestment",
    "rate": 0.0615,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeCapitalGains",
    "i_taxationType": "longTermCapitalGains",
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Interest Income (Taxable)",
    "experienceKey": "IncomeInvestment",
    "rate": 0.0615,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeYieldsTaxable",
    "i_taxationType": "interestOrdinaryDividends",
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Interest Income (Tax Free)",
    "experienceKey": "IncomeInvestment",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeYieldsTaxExempt",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Ordinary Dividends",
    "experienceKey": "IncomeInvestment",
    "rate": 0.0615,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeDividendsOrdinary",
    "i_taxationType": "interestOrdinaryDividends",
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Qualified Dividends",
    "experienceKey": "IncomeInvestment",
    "rate": 0.0615,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeDividendsQualified",
    "i_taxationType": "qualifiedDividends",
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Gifts",
    "experienceKey": "IncomeMiscellaneous",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeGifts",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Inheritance",
    "experienceKey": "IncomeMiscellaneous",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeInheritance",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Withdrawals (Taxable)",
    "experienceKey": "IncomeMiscellaneous",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeWithdrawalTaxable",
    "i_taxationType": "otherIncome",
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Withdrawals (Tax Free)",
    "experienceKey": "IncomeMiscellaneous",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeWithdrawalTaxExempt",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Other",
    "experienceKey": "IncomeMiscellaneous",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeOther",
    "i_taxationType": "otherIncome",
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Net Rental Income",
    "experienceKey": "IncomeProperty",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": true,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeRentalNet",
    "i_taxationType": "rentalIncome",
    "adjustmentWeight": 1,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Royalty Income",
    "experienceKey": "IncomeProperty",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeRoyaltyNet",
    "i_taxationType": "rentalIncome",
    "adjustmentWeight": 1,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Pension",
    "experienceKey": "IncomeRetirement",
    "rate": 0.024,
    "startAtAge": "age_social_security",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomePension",
    "i_taxationType": "pensionIraDistributions",
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Social Security Benefits",
    "experienceKey": "IncomeRetirement",
    "rate": 0.024,
    "startAtAge": "age_social_security",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeSocialSecurity",
    "i_taxationType": "socialSecurityBenefits",
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Required Distributions",
    "experienceKey": "IncomeRetirement",
    "rate": 0.024,
    "startAtAge": "age_required_distributions",
    "endAtAge": "age_death",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeRequiredDistributionsTaxable",
    "i_taxationType": "pensionIraDistributions",
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Roth IRA Distributions",
    "experienceKey": "IncomeRetirement",
    "rate": 0.024,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeRequiredDistributionsTaxExempt",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Annuity",
    "experienceKey": "IncomeRetirement",
    "rate": 0.024,
    "startAtAge": "age_social_security",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeAnnuity",
    "i_taxationType": "pensionIraDistributions",
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Net Active Business / Partner Income",
    "experienceKey": "IncomeEntrepreneurship",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": true,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeEntrepreneurshipActive",
    "i_taxationType": "selfEmploymentGrossRevenue",
    "adjustmentWeight": 1,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Passive Partner Share K-1",
    "experienceKey": "IncomeEntrepreneurship",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeEntrepreneurshipPassive",
    "i_taxationType": "k1Income",
    "adjustmentWeight": 1,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "S-Corp Net Distribution K-1",
    "experienceKey": "IncomeEntrepreneurship",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeEntrepreneurshipSCorpK1",
    "i_taxationType": "k1Income",
    "adjustmentWeight": 1,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Partnership Guaranteed Payments",
    "experienceKey": "IncomeEntrepreneurship",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeEntrepreneurshipGuaranteedPayments",
    "i_taxationType": "selfEmploymentGrossRevenue",
    "adjustmentWeight": 1,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Tax-Exempt",
    "experienceKey": "IncomeSpecial",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeTaxExempt",
    "i_taxationType": "taxExemptInterest",
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Purchase",
    "experienceKey": "ExpensesPlanned",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesPurchase",
    "i_taxationType": null,
    "adjustmentWeight": 1,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Renovation",
    "experienceKey": "ExpensesPlanned",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesRenovation",
    "i_taxationType": null,
    "adjustmentWeight": 1,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Vacation",
    "experienceKey": "ExpensesPlanned",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesVacation",
    "i_taxationType": null,
    "adjustmentWeight": 1,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Traveling",
    "experienceKey": "ExpensesPlanned",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesTraveling",
    "i_taxationType": null,
    "adjustmentWeight": 1,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Daily Living",
    "experienceKey": "ExpensesGeneral",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesDailyLiving",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Rent",
    "experienceKey": "ExpensesGeneral",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesRent",
    "i_taxationType": null,
    "adjustmentWeight": 0.1,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Car",
    "experienceKey": "ExpensesGeneral",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesCar",
    "i_taxationType": null,
    "adjustmentWeight": 0.1,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Transportation",
    "experienceKey": "ExpensesGeneral",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesTransportation",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Pets",
    "experienceKey": "ExpensesGeneral",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesPets",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Grocery",
    "experienceKey": "ExpensesGeneral",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesGrocery",
    "i_taxationType": null,
    "adjustmentWeight": 0.2,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Entertainment",
    "experienceKey": "ExpensesGeneral",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesEntertainment",
    "i_taxationType": null,
    "adjustmentWeight": 1,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Shopping",
    "experienceKey": "ExpensesGeneral",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesShopping",
    "i_taxationType": null,
    "adjustmentWeight": 0.2,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Subscription",
    "experienceKey": "ExpensesGeneral",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesSubscription",
    "i_taxationType": null,
    "adjustmentWeight": 0.5,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "TV",
    "experienceKey": "ExpensesGeneral",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesTV",
    "i_taxationType": null,
    "adjustmentWeight": 0.9,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Mobile",
    "experienceKey": "ExpensesGeneral",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesMobile",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Other",
    "experienceKey": "ExpensesGeneral",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesOther",
    "i_taxationType": null,
    "adjustmentWeight": 0.2,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Gifts",
    "experienceKey": "ExpensesMiscellaneous",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesGifts",
    "i_taxationType": null,
    "adjustmentWeight": 1,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Charity",
    "experienceKey": "ExpensesMiscellaneous",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesCharity",
    "i_taxationType": null,
    "adjustmentWeight": 1,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Credit Interest",
    "experienceKey": "ExpensesObligation",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesCreditInterest",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "e_isAdjustable": false,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Credit Principal",
    "experienceKey": "ExpensesObligation",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesCreditPrincipal",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "e_isAdjustable": false,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Medicare Payment",
    "experienceKey": "ExpensesObligation",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesMedicare",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Education Payment",
    "experienceKey": "ExpensesObligation",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesEducation",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Insurance Payment",
    "experienceKey": "ExpensesObligation",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesInsurance",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Water",
    "experienceKey": "ExpensesProperty",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesWater",
    "i_taxationType": null,
    "adjustmentWeight": 0.1,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Electricity",
    "experienceKey": "ExpensesProperty",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesElectricity",
    "i_taxationType": null,
    "adjustmentWeight": 0.1,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Trash",
    "experienceKey": "ExpensesProperty",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesTrash",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Internet",
    "experienceKey": "ExpensesProperty",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesInternet",
    "i_taxationType": null,
    "adjustmentWeight": 0.1,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "HOA fees",
    "experienceKey": "ExpensesProperty",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesHoa",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Landscape",
    "experienceKey": "ExpensesProperty",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesLandscape",
    "i_taxationType": null,
    "adjustmentWeight": 1,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Gas",
    "experienceKey": "ExpensesProperty",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesGas",
    "i_taxationType": null,
    "adjustmentWeight": 0.1,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Business expenses",
    "experienceKey": "ExpensesEntrepreneurship",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesBusinessCosts",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Owner Contribution",
    "experienceKey": "ContributionsGeneral",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catContributionsOwner",
    "i_taxationType": null,
    "adjustmentWeight": 1,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Employer Contribution",
    "experienceKey": "ContributionsGeneral",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_retirement",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catContributionsEmployer",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Investment",
    "experienceKey": "ContributionsGeneral",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catContributionsAuto",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Standard",
    "experienceKey": "TaxesBenefit",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catTaxesDeductionsStandard",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Itemized",
    "experienceKey": "TaxesBenefit",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_now",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catTaxesDeductionsItemized",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Federal Tax Credits",
    "experienceKey": "TaxesBenefit",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catTaxesCreditFederal",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "State Tax Credits",
    "experienceKey": "TaxesBenefit",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catTaxesCreditState",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "State Tax Exemptions",
    "experienceKey": "TaxesBenefit",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catTaxesTaxExempt",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Capital Gains",
    "experienceKey": "TaxesIncome",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catTaxesCapitalGains",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "State Income Tax",
    "experienceKey": "TaxesIncome",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catTaxesIncomeState",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Federal Income Tax",
    "experienceKey": "TaxesIncome",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catTaxesIncomeFederal",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Net Investment Income Tax (NIIT)",
    "experienceKey": "TaxesOther",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catTaxesNetInvestmentIncomeFederal",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Additional Medicare Tax",
    "experienceKey": "TaxesOther",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catTaxesMedicareAdditionalFederal",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Alternative Minimum Tax (AMT)",
    "experienceKey": "TaxesOther",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catTaxesAlternativeMinimumFederal",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Medicare Tax (W-2)",
    "experienceKey": "TaxesFica",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catTaxesMedicareW2Federal",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Social Security Tax (W-2)",
    "experienceKey": "TaxesFica",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catTaxesSocialSecurityW2Federal",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Property Tax",
    "experienceKey": "TaxesProperty",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catTaxesProperty",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "e_isAdjustable": false,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Social Security Tax (SE)",
    "experienceKey": "TaxesEntrepreneurship",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catTaxesSocialSecurityEntrepreneurshipFederal",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Medicare Tax (SE)",
    "experienceKey": "TaxesEntrepreneurship",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catTaxesMedicareEntrepreneurshipFederal",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Free Cash",
    "experienceKey": "TechnicalTransaction",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catAssetsCash",
    "key": "catTechnicalVirtualBalance",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "ROTH conversion",
    "experienceKey": "Transfer",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catTechnicalRothConversion",
    "i_taxationType": null,
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "LLC Equity",
    "experienceKey": "AssetsEquity",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsLLC",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "S-Corp Equity",
    "experienceKey": "AssetsEquity",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsSCorp",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "C-Corp Equity",
    "experienceKey": "AssetsEquity",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsCCorp",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Partnership Equity",
    "experienceKey": "AssetsEquity",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsPartnership",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Sole Proprietorship Assets",
    "experienceKey": "AssetsEquity",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsSoleProprietorship",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Flexible Spending Account (FSA)",
    "experienceKey": "AssetsInvestment",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catExpensesMedicare",
    "key": "catAssetsSavingsFsa",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Employee Stock Ownership Plan",
    "experienceKey": "AssetsRetirement",
    "rate": 0.0615,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsESOP",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": true,
    "a_isLiquid": false,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": "catTechnicalVirtualBalance",
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxable"
  },
  {
    "name": "Employee Stock Purchase Plan",
    "experienceKey": "AssetsEquity",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsESPP",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": "catIncomeCapitalGains",
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": 9,
    "a_withdrawalCategoryKey": "catIncomeCapitalGains"
  },
  {
    "name": "Health Insurance",
    "experienceKey": "ExpensesInsurance",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesHealthInsurance",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Disability Insurance",
    "experienceKey": "ExpensesInsurance",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesDisabilityInsurance",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Short-Term Disability Insurance",
    "experienceKey": "ExpensesInsurance",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesShortTermDisability",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Long-Term Care Insurance",
    "experienceKey": "ExpensesInsurance",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesLTCInsurance",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Auto Insurance",
    "experienceKey": "ExpensesInsurance",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesAutoInsurance",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Umbrella Insurance",
    "experienceKey": "ExpensesInsurance",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesUmbrellaInsurance",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Home / Property Insurance",
    "experienceKey": "ExpensesInsurance",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesHomeInsurance",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Renters Insurance",
    "experienceKey": "ExpensesInsurance",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesRentersInsurance",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Pet Insurance",
    "experienceKey": "ExpensesInsurance",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesPetInsurance",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Thrift Savings Plan (TSP)",
    "experienceKey": "AssetsRetirement",
    "rate": 0.0615,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsIraTsp",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": true,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": "catTechnicalVirtualBalance",
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": 16,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxable"
  },
  {
    "name": "Roth TSP",
    "experienceKey": "AssetsRetirement",
    "rate": 0.0615,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsIraTspRoth",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": true,
    "a_topUpCategoryKey": "catContributionsOwner",
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": "catIncomeYieldsTaxExempt",
    "a_drawDownOrder": 25,
    "a_withdrawalCategoryKey": "catIncomeWithdrawalTaxExempt"
  },
  {
    "name": "Medicare Benefit",
    "experienceKey": "CoverageBenefits",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catCoverageMedicareBenefit",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Death Benefit",
    "experienceKey": "CoverageBenefits",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catCoverageDeathBenefit",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Vehicle Insurance",
    "experienceKey": "CoverageBenefits",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catCoverageVehicleLimit",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Pet Insurance",
    "experienceKey": "CoverageBenefits",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catCoveragePetLimit",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Homeowners, Renters Insurance",
    "experienceKey": "CoverageBenefits",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catCoveragePropertyLimit",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Umbrella Insurance",
    "experienceKey": "CoverageBenefits",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catCoverageUmbrellaLimit",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Quest Scenario",
    "experienceKey": "TechnicalQuest",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": true,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catTechnicalQuestScenario",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Medical Procedures",
    "experienceKey": "ExpensesPlanned",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesMedical",
    "i_taxationType": null,
    "adjustmentWeight": 1,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Vehicle",
    "experienceKey": "AssetsMiscellaneous",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": null,
    "key": "catAssetsVehicle",
    "i_taxationType": null,
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "RSU Vesting",
    "experienceKey": "IncomeEmployment",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_retirement",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeRSU",
    "i_taxationType": "w2Wages",
    "adjustmentWeight": 0,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "Childcare",
    "experienceKey": "ExpensesGeneral",
    "rate": 0.035,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catExpensesChildcare",
    "i_taxationType": null,
    "adjustmentWeight": 0.1,
    "e_isAdjustable": true,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  },
  {
    "name": "ISO Bargain Element (AMT)",
    "experienceKey": "IncomeSpecial",
    "rate": 0,
    "startAtAge": "age_now",
    "endAtAge": "age_death",
    "isTechnical": false,
    "isActiveIncome": false,
    "doubleEntryCategoryKey": "catTechnicalVirtualBalance",
    "key": "catIncomeISOBargainElement",
    "i_taxationType": "amtAddBacks",
    "adjustmentWeight": null,
    "a_isRequiredDistributionsBase": false,
    "a_isLiquid": false,
    "a_topUpCategoryKey": null,
    "a_closeCategoryKey": null,
    "a_recurrentInflowCategoryKey": null,
    "a_drawDownOrder": null,
    "a_withdrawalCategoryKey": null
  }
]
